import Ajv from "ajv";
/**
 Required properties are missing from object: tipologia, tipologia_offerta, campagna, cellulare_lead, frazione_intestatario, delegatocorrispondecliente, tecnologiaConnessione, migrazioneONuovaLinea, codiceDiMigrazione, id_vici, ele_mercato_provenienza, prodotto_elettrico, gas_mercato_provenienza, codice_contratto_elettrico, codice_contratto_gas, check_pod, check_pdr.
 */
const CrmService = {
    defaultCrmMappingId: 1,
    init: function () {
        window.defaultCrmMappingId = CrmService.defaultCrmMappingId;
    },
    getCrmFormMapping: function (contract) {
        if(window.crmMap){
            var map = {};
            map[contract.id] = window.crmMap;
            return map;
        }
        return {};
        // return {
        //     254: this.defaultCrmMappingId,
        //     324: this.defaultCrmMappingId,
        // };
    },
    isFormConnectedToCrm: function (contract) {
        // fixed ids for now
        // return [254].includes(contract.id);
        const mapping = this.getCrmFormMapping(contract);
        return contract.id in mapping;
    },
    getFormMappingId: function (contract) {
        const mapping = this.getCrmFormMapping(contract);
        return mapping[contract.id];
    },
    openDestinationUrlBefore: function () {
        let newWindow = null;
        try {
            newWindow = window.open("", "_blank");
            // write a wait message to the new window
            newWindow.document.write("Please wait while we are redirecting you to the CRM...");
        }catch (e){
            console.error(e);
        }
        return newWindow;
    },
    openDestinationUrl: function (newWindow, contract, submissionData, formData, submission) {
        if(!newWindow){
            return; // user closed the window or it was blocked
        }
        // const url = this.getFormMapDestinationUrl(contract, submissionData);
        let url = this.getFormMapDestinationUrl(contract, formData.data);
        if(submission.id){
            // append submission id to the url
            url += '&fastsignSubmissionId='+submission.id;
        }
        newWindow.location = url;
    },
    getFormMapDestinationUrl: function(contract,data){
        const id = this.getFormMappingId(contract);
        const base = 'https://app.soloweb.net/#/document/form/'+id;

        const schema = this.getCRMLeadSchema();

        // Extract valid keys from the schema
        const validKeys = schema.properties ? Object.keys(schema.properties) : [];

        const query = {};

        let formdata = {};
        Object.keys(data).forEach(key => {
            // Only add keys that exist in the valid keys from the schema
            if (validKeys.includes(key)) {
                formdata[key] = data[key];
            }
        });

        query.formdata = JSON.stringify(formdata);

        const queryString = new URLSearchParams(query).toString();
        return base + '?' + queryString;
    },
    /**
     * Check if the form has the needed fields to be submitted to the CRM.
     * @param formioConfig
     */
    validateSchema: function (formioConfig) {
        const ajv = new Ajv({allErrors: true});

        // const schema = {
        //     type: "object",
        //     properties: {
        //         foo: {type: "integer"},
        //         bar: {type: "string"},
        //     },
        //     required: ["foo"],
        //     additionalProperties: false,
        // }

        const schema = this.getCRMLeadSchema();
        //
        // const data = {
        //     fooa: 1,
        //     bar: "abc",
        // }

        const data = this.getFormFieldsForSchemaValidation(formioConfig);
        const crmMapped = this.getFormOverrideForSchemaValidation();
        Object.assign(data, crmMapped);

        const validate = ajv.compile(schema)
        const valid = validate(data)
        if (!valid){
            return validate.errors;
        }
        return true;
    },
    getFormOverrideForSchemaValidation: function (formdata) {
        if(!formdata){
            // maybe todo
            formdata = {};
        }
        /*
        Example:
        https://app.fastsign.it/#/document/form/254
        window.crmMap = CrmService.defaultCrmMappingId;
        window.crmMapper = (data) => {
            return {"tipologia":"switch"};
        }
        */
        if(window.crmMapper){
            return window.crmMapper(formdata);
        }
        return {};
    },
    getFormFilledData: function (formioConfig) {

    },
    getFormFieldsForSchemaValidation: function (formioConfig) {
        let extractFormConfigJsonForValidation = (nestedObject) => {
            let result = {};

            function traverse(obj) {
                if (!obj || typeof obj !== 'object') return;

                // Check if the current object is a valid select, checkbox, or radio without API
                if (
                    ['select', 'checkbox', 'radio'].includes(obj.type) &&
                    obj.data &&
                    obj.data.values
                ) {
                    // Store values joined by '|'
                    result[obj.key] = obj.data.values.map(v => v.value).join('|');
                } else if (
                    ['select', 'checkbox', 'radio'].includes(obj.type) &&
                    obj.values
                ) {
                    // Store values joined by '|'
                    result[obj.key] = obj.values.map(v => v.value).join('|');
                } else {
                    result[obj.key] = '';
                }

                // Recursively traverse "components" array
                if (Array.isArray(obj.components)) {
                    obj.components.forEach(traverse);
                }

                // Recursively traverse "columns" array
                if (Array.isArray(obj.columns)) {
                    obj.columns.forEach(traverse);
                }
            }

            traverse(nestedObject);
            return result;
        };
        // extractFormConfigJsonForValidation(window.formioinstance.form)
        return extractFormConfigJsonForValidation(formioConfig);
    },
    getCRMLeadSchema: function () {
        const validationSchema = {
            "$schema": "http://json-schema.org/draft-07/schema#",
            "title": "CRM lead schema",
            "type": "object",
            "properties": {
                "tipoCliente": {
                    "type": "string",
                    "enum": [
                        "residenziale|business"
                    ]
                },
                "tipologia": {
                    "type": "string",
                    "enum": [
                        "standard|voltura|pertinenze"
                    ]
                },
                "tipologia_offerta": {
                    "type": "string"
                },
                "tipocontratto": {
                    "type": "string"
                },
                "campagna": {
                    "type": "string"
                },
                "nome": {
                    "type": "string"
                },
                "cognome": {
                    "type": "string"
                },
                "data_nascita": {
                    "type": "string"
                },
                "luogo_nascita": {
                    "type": "string"
                },
                "stato_nascita": {
                    "type": "string"
                },
                "genere": {
                    "type": "string",
                    "enum": [
                        "M|F"
                    ]
                },
                "codice_fiscale": {
                    "type": "string"
                },
                "cellulare_intestatario": {
                    "type": "string"
                },
                "email_intestatario": {
                    "type": "string"
                },
                "telefono_intestatario": {
                    "type": "string"
                },
                "cellulare_lead": {
                    "type": "string"
                },
                "tipo_documento": {
                    "type": "string"
                },
                "numero_documento": {
                    "type": "string"
                },
                "ente_rilascio_documento": {
                    "type": "string",
                    "enum": [
                        "comune|prefettura|motorizzazione"
                    ]
                },
                "data_rilascio_documento": {
                    "type": "string"
                },
                "titolarita_fornitura": {
                    "type": "string"
                },
                "modalita_bolletta": {
                    "type": "string",
                    "enum": [
                        "cartaceo|online"
                    ]
                },
                "tipo_indirizzo_intestatario": {
                    "type": "string"
                },
                "indirizzo_intestatario": {
                    "type": "string"
                },
                "numero_civico_intestatario": {
                    "type": "string"
                },
                "provincia_intestatario": {
                    "type": "string"
                },
                "localita_intestatario": {
                    "type": "string"
                },
                "frazione_intestatario": {
                    "type": "string"
                },
                "indirizzofornituracorrisponderesidenza": {
                    "type": "string"
                },
                "indirizzorecapitocorrisponderesidenza": {
                    "type": "string"
                },
                "delegatocorrispondecliente": {
                    "type": "string"
                },
                "tipo_pagamento": {
                    "type": "string",
                    "enum": [
                        "rid|6",
                        "6|rid"
                    ]
                },
                "tecnologiaConnessione": {
                    "type": "string",
                    "enum": [
                        "ftth|fttc|fwa"
                    ]
                },
                "migrazioneONuovaLinea": {
                    "type": "string",
                    "enum": [
                        "migrazione|nuovalinea"
                    ]
                },
                "codiceDiMigrazione": {
                    "type": "string"
                },
                "consenso_marketing": {
                    "type": "string"
                },
                "consenso_profilazione": {
                    "type": "string"
                },
                "consenso_terzi": {
                    "type": "string"
                },
                "id_vici": {
                    "type": "string"
                },
                "ele_pod": {
                    "type": "string"
                },
                "ele_mercato_provenienza": {
                    "type": "string"
                },
                "ele_potenza_impegnata": {
                    "type": "string"
                },
                "prodotto_elettrico": {
                    "type": "string"
                },
                "ele_ex_societa_vendita": {
                    "type": "string"
                },
                "gas_pdr": {
                    "type": "string"
                },
                "gas_mercato_provenienza": {
                    "type": "string"
                },
                "gas_categoria_uso_aeeg": {
                    "type": "string"
                },
                "prodotto_gas": {
                    "type": "string"
                },
                "gas_ex_societa_vendita": {
                    "type": "string"
                },
                "codice_iban": {
                    "type": "string"
                },
                "nome_banca": {
                    "type": "string"
                },
                "contoTitolareFornitura": {
                    "type": "string"
                },
                "ele_consumo_annuo": {
                    "type": "string"
                },
                "codice_contratto_elettrico": {
                    "type": "string"
                },
                "gas_consumo_annuo": {
                    "type": "string"
                },
                "codice_contratto_gas": {
                    "type": "string"
                },
                "check_pod": {
                    "type": "string"
                },
                "check_pdr": {
                    "type": "string"
                }
            },
            "required": [
                "tipoCliente",
                "tipologia",
                "tipologia_offerta",
                "tipocontratto",
                "campagna",
                "nome",
                "cognome",
                "data_nascita",
                "luogo_nascita",
                "stato_nascita",
                "genere",
                "codice_fiscale",
                "cellulare_intestatario",
                "email_intestatario",
                "telefono_intestatario",
                "cellulare_lead",
                "tipo_documento",
                "numero_documento",
                "ente_rilascio_documento",
                "data_rilascio_documento",
                "titolarita_fornitura",
                "modalita_bolletta",
                "tipo_indirizzo_intestatario",
                "indirizzo_intestatario",
                "numero_civico_intestatario",
                "provincia_intestatario",
                "localita_intestatario",
                "frazione_intestatario",
                "indirizzofornituracorrisponderesidenza",
                "indirizzorecapitocorrisponderesidenza",
                "delegatocorrispondecliente",
                "tipo_pagamento",
                "tecnologiaConnessione",
                "migrazioneONuovaLinea",
                "codiceDiMigrazione",
                "consenso_marketing",
                "consenso_profilazione",
                "consenso_terzi",
                "id_vici",
                "ele_pod",
                "ele_mercato_provenienza",
                "ele_potenza_impegnata",
                "prodotto_elettrico",
                "ele_ex_societa_vendita",
                "gas_pdr",
                "gas_mercato_provenienza",
                "gas_categoria_uso_aeeg",
                "prodotto_gas",
                "gas_ex_societa_vendita",
                "codice_iban",
                "nome_banca",
                "contoTitolareFornitura",
                "ele_consumo_annuo",
                "codice_contratto_elettrico",
                "gas_consumo_annuo",
                "codice_contratto_gas",
                "check_pod",
                "check_pdr"
            ]
        };
        return validationSchema;
    },
    getCRMLeadSchemaNO: function (formioConfig) {
        const validationSchema = {
            "$schema": "http://json-schema.org/draft-07/schema#",
            "title": "CRM lead schema",
            "type": "object",
            "properties": {
                "tipoCliente": {
                    "type": "string",
                    "enum": [
                        "residenziale",
                        "business"
                    ]
                },
                "tipologia": {
                    "type": "string",
                    "enum": [
                        "standard",
                        "voltura",
                        "pertinenze"
                    ]
                },
                "tipologia_offerta": {
                    "type": "object",
                    "properties": {
                        "id": {
                            "type": "number"
                        },
                        "item_key": {
                            "type": "string"
                        },
                        "label": {
                            "type": "string"
                        },
                        "additional": {}
                    },
                    "required": [
                        "id",
                        "item_key",
                        "label",
                        "additional"
                    ]
                },
                "tipocontratto": {
                    "type": "object",
                    "properties": {
                        "contrattoLuce": {
                            "type": "boolean"
                        },
                        "contrattoGAS": {
                            "type": "boolean"
                        }
                    },
                    "required": [
                        "contrattoLuce",
                        "contrattoGAS"
                    ]
                },
                "campagna": {
                    "type": "object",
                    "properties": {
                        "id": {
                            "type": "number"
                        },
                        "item_key": {},
                        "label": {
                            "type": "string"
                        },
                        "additional": {
                            "type": "string"
                        }
                    },
                    "required": [
                        "id",
                        "item_key",
                        "label",
                        "additional"
                    ]
                },
                "nome": {
                    "type": "string"
                },
                "cognome": {
                    "type": "string"
                },
                "data_nascita": {
                    "type": "string"
                },
                "luogo_nascita": {
                    "type": "object",
                    "properties": {
                        "id": {
                            "type": "number"
                        },
                        "item_key": {
                            "type": "string"
                        },
                        "label": {
                            "type": "string"
                        },
                        "provincia": {
                            "type": "string"
                        },
                        "cap": {
                            "type": "string"
                        },
                        "codice_catastale": {
                            "type": "string"
                        },
                        "additional": {},
                        "swi_int": {
                            "type": "number"
                        },
                        "swi_fat": {
                            "type": "number"
                        },
                        "swi_fru_ele": {
                            "type": "number"
                        },
                        "swi_fru_gas": {
                            "type": "number"
                        },
                        "swi_luo_nas": {
                            "type": "number"
                        }
                    },
                    "required": [
                        "id",
                        "item_key",
                        "label",
                        "provincia",
                        "cap",
                        "codice_catastale",
                        "additional",
                        "swi_int",
                        "swi_fat",
                        "swi_fru_ele",
                        "swi_fru_gas",
                        "swi_luo_nas"
                    ]
                },
                "stato_nascita": {
                    "type": "object",
                    "properties": {
                        "id": {
                            "type": "number"
                        },
                        "item_key": {
                            "type": "string"
                        },
                        "label": {
                            "type": "string"
                        },
                        "iso": {
                            "type": "string"
                        },
                        "additional": {}
                    },
                    "required": [
                        "id",
                        "item_key",
                        "label",
                        "iso",
                        "additional"
                    ]
                },
                "genere": {
                    "type": "string",
                    "enum": [
                        "M",
                        "F"
                    ]
                },
                "codice_fiscale": {
                    "type": "string"
                },
                "cellulare_intestatario": {
                    "type": "string"
                },
                "email_intestatario": {
                    "type": "string"
                },
                "telefono_intestatario": {
                    "type": "string"
                },
                "cellulare_lead": {
                    "type": "string"
                },
                "tipo_documento": {
                    "type": "object",
                    "properties": {
                        "id": {
                            "type": "number"
                        },
                        "item_key": {
                            "type": "string"
                        },
                        "label": {
                            "type": "string"
                        },
                        "additional": {
                            "type": "string"
                        }
                    },
                    "required": [
                        "id",
                        "item_key",
                        "label",
                        "additional"
                    ]
                },
                "numero_documento": {
                    "type": "string"
                },
                "ente_rilascio_documento": {
                    "type": "string",
                    "enum": [
                        "comune",
                        "prefettura",
                        "motorizzazione"
                    ]
                },
                "data_rilascio_documento": {
                    "type": "string"
                },
                "titolarita_fornitura": {
                    "type": "object",
                    "properties": {
                        "id": {
                            "type": "number"
                        },
                        "item_key": {
                            "type": "string"
                        },
                        "label": {
                            "type": "string"
                        },
                        "additional": {}
                    },
                    "required": [
                        "id",
                        "item_key",
                        "label",
                        "additional"
                    ]
                },
                "modalita_bolletta": {
                    "type": "string",
                    "enum": [
                        "cartaceo",
                        "online"
                    ]
                },
                "tipo_indirizzo_intestatario": {
                    "type": "object",
                    "properties": {
                        "id": {
                            "type": "number"
                        },
                        "item_key": {
                            "type": "string"
                        },
                        "label": {
                            "type": "string"
                        },
                        "additional": {}
                    },
                    "required": [
                        "id",
                        "item_key",
                        "label",
                        "additional"
                    ]
                },
                "indirizzo_intestatario": {
                    "type": "string"
                },
                "numero_civico_intestatario": {
                    "type": "string"
                },
                "provincia_intestatario": {
                    "type": "object",
                    "properties": {
                        "id": {
                            "type": "number"
                        },
                        "item_key": {
                            "type": "string"
                        },
                        "label": {
                            "type": "string"
                        },
                        "code": {
                            "type": "string"
                        }
                    },
                    "required": [
                        "id",
                        "item_key",
                        "label",
                        "code"
                    ]
                },
                "localita_intestatario": {
                    "type": "object",
                    "properties": {
                        "id": {
                            "type": "number"
                        },
                        "item_key": {
                            "type": "string"
                        },
                        "label": {
                            "type": "string"
                        },
                        "provincia": {
                            "type": "string"
                        },
                        "cap": {
                            "type": "string"
                        },
                        "codice_catastale": {
                            "type": "string"
                        },
                        "additional": {},
                        "swi_int": {
                            "type": "number"
                        },
                        "swi_fat": {
                            "type": "number"
                        },
                        "swi_fru_ele": {
                            "type": "number"
                        },
                        "swi_fru_gas": {
                            "type": "number"
                        },
                        "swi_luo_nas": {
                            "type": "number"
                        }
                    },
                    "required": [
                        "id",
                        "item_key",
                        "label",
                        "provincia",
                        "cap",
                        "codice_catastale",
                        "additional",
                        "swi_int",
                        "swi_fat",
                        "swi_fru_ele",
                        "swi_fru_gas",
                        "swi_luo_nas"
                    ]
                },
                "frazione_intestatario": {
                    "type": "object",
                    "properties": {},
                    "required": []
                },
                "indirizzofornituracorrisponderesidenza": {
                    "type": "boolean"
                },
                "indirizzorecapitocorrisponderesidenza": {
                    "type": "boolean"
                },
                "delegatocorrispondecliente": {
                    "type": "boolean"
                },
                "tipo_pagamento": {
                    "type": "string",
                    "enum": [
                        "rid",
                        "6"
                    ]
                },
                "tecnologiaConnessione": {
                    "type": "string",
                    "enum": [
                        "ftth",
                        "fttc",
                        "fwa"
                    ]
                },
                "migrazioneONuovaLinea": {
                    "type": "string",
                    "enum": [
                        "migrazione",
                        "nuovalinea"
                    ]
                },
                "codiceDiMigrazione": {
                    "type": "string"
                },
                "consenso_marketing": {
                    "type": "boolean"
                },
                "consenso_profilazione": {
                    "type": "boolean"
                },
                "consenso_terzi": {
                    "type": "boolean"
                },
                "id_vici": {
                    "type": "string"
                },
                "ele_pod": {
                    "type": "string"
                },
                "ele_mercato_provenienza": {
                    "type": "object",
                    "properties": {
                        "id": {
                            "type": "number"
                        },
                        "item_key": {
                            "type": "string"
                        },
                        "label": {
                            "type": "string"
                        },
                        "additional": {}
                    },
                    "required": [
                        "id",
                        "item_key",
                        "label",
                        "additional"
                    ]
                },
                "ele_potenza_impegnata": {
                    "type": "number"
                },
                "prodotto_elettrico": {
                    "type": "object",
                    "properties": {
                        "id": {
                            "type": "number"
                        },
                        "item_key": {
                            "type": "string"
                        },
                        "label": {
                            "type": "string"
                        },
                        "code": {
                            "type": "string"
                        },
                        "valid_from": {
                            "type": "string"
                        },
                        "valid_to": {},
                        "tipo_ser": {
                            "type": "string"
                        },
                        "des_soc": {
                            "type": "string"
                        },
                        "cod_soc": {
                            "type": "string"
                        },
                        "des_par": {
                            "type": "string"
                        },
                        "des_seg_off": {
                            "type": "string"
                        },
                        "des_uso_for": {
                            "type": "string"
                        },
                        "des_ope": {},
                        "cod_tip_con": {
                            "type": "string"
                        }
                    },
                    "required": [
                        "id",
                        "item_key",
                        "label",
                        "code",
                        "valid_from",
                        "valid_to",
                        "tipo_ser",
                        "des_soc",
                        "cod_soc",
                        "des_par",
                        "des_seg_off",
                        "des_uso_for",
                        "des_ope",
                        "cod_tip_con"
                    ]
                },
                "ele_ex_societa_vendita": {
                    "type": "object",
                    "properties": {
                        "id": {
                            "type": "number"
                        },
                        "item_key": {
                            "type": "string"
                        },
                        "label": {
                            "type": "string"
                        },
                        "ope": {
                            "type": "string"
                        },
                        "servizio": {
                            "type": "string"
                        },
                        "additional": {},
                        "valid_from": {},
                        "valid_to": {}
                    },
                    "required": [
                        "id",
                        "item_key",
                        "label",
                        "ope",
                        "servizio",
                        "additional",
                        "valid_from",
                        "valid_to"
                    ]
                },
                "gas_pdr": {
                    "type": "string"
                },
                "gas_mercato_provenienza": {
                    "type": "object",
                    "properties": {
                        "id": {
                            "type": "number"
                        },
                        "item_key": {
                            "type": "string"
                        },
                        "label": {
                            "type": "string"
                        },
                        "additional": {}
                    },
                    "required": [
                        "id",
                        "item_key",
                        "label",
                        "additional"
                    ]
                },
                "gas_categoria_uso_aeeg": {
                    "type": "object",
                    "properties": {
                        "id": {
                            "type": "number"
                        },
                        "item_key": {
                            "type": "string"
                        },
                        "label": {
                            "type": "string"
                        },
                        "additional": {}
                    },
                    "required": [
                        "id",
                        "item_key",
                        "label",
                        "additional"
                    ]
                },
                "prodotto_gas": {
                    "type": "object",
                    "properties": {
                        "id": {
                            "type": "number"
                        },
                        "item_key": {
                            "type": "string"
                        },
                        "label": {
                            "type": "string"
                        },
                        "code": {
                            "type": "string"
                        },
                        "valid_from": {
                            "type": "string"
                        },
                        "valid_to": {},
                        "tipo_ser": {
                            "type": "string"
                        },
                        "des_soc": {
                            "type": "string"
                        },
                        "cod_soc": {
                            "type": "string"
                        },
                        "des_par": {
                            "type": "string"
                        },
                        "des_seg_off": {
                            "type": "string"
                        },
                        "des_uso_for": {
                            "type": "string"
                        },
                        "des_ope": {},
                        "cod_tip_con": {
                            "type": "string"
                        }
                    },
                    "required": [
                        "id",
                        "item_key",
                        "label",
                        "code",
                        "valid_from",
                        "valid_to",
                        "tipo_ser",
                        "des_soc",
                        "cod_soc",
                        "des_par",
                        "des_seg_off",
                        "des_uso_for",
                        "des_ope",
                        "cod_tip_con"
                    ]
                },
                "gas_ex_societa_vendita": {
                    "type": "object",
                    "properties": {
                        "id": {
                            "type": "number"
                        },
                        "item_key": {
                            "type": "string"
                        },
                        "label": {
                            "type": "string"
                        },
                        "ope": {
                            "type": "string"
                        },
                        "servizio": {
                            "type": "string"
                        },
                        "additional": {},
                        "valid_from": {},
                        "valid_to": {}
                    },
                    "required": [
                        "id",
                        "item_key",
                        "label",
                        "ope",
                        "servizio",
                        "additional",
                        "valid_from",
                        "valid_to"
                    ]
                },
                "codice_iban": {
                    "type": "string"
                },
                "nome_banca": {
                    "type": "string"
                },
                "contoTitolareFornitura": {
                    "type": "boolean"
                },
                "ele_consumo_annuo": {
                    "type": "number"
                },
                "codice_contratto_elettrico": {
                    "type": "string"
                },
                "gas_consumo_annuo": {
                    "type": "number"
                },
                "codice_contratto_gas": {
                    "type": "string"
                },
                "check_pod": {
                    "type": "object",
                    "properties": {},
                    "required": []
                },
                "check_pdr": {
                    "type": "object",
                    "properties": {},
                    "required": []
                }
            },
            "required": [
                "tipoCliente",
                "tipologia",
                "tipologia_offerta",
                "tipocontratto",
                "campagna",
                "nome",
                "cognome",
                "data_nascita",
                "luogo_nascita",
                "stato_nascita",
                "genere",
                "codice_fiscale",
                "cellulare_intestatario",
                "email_intestatario",
                "telefono_intestatario",
                "cellulare_lead",
                "tipo_documento",
                "numero_documento",
                "ente_rilascio_documento",
                "data_rilascio_documento",
                "titolarita_fornitura",
                "modalita_bolletta",
                "tipo_indirizzo_intestatario",
                "indirizzo_intestatario",
                "numero_civico_intestatario",
                "provincia_intestatario",
                "localita_intestatario",
                "frazione_intestatario",
                "indirizzofornituracorrisponderesidenza",
                "indirizzorecapitocorrisponderesidenza",
                "delegatocorrispondecliente",
                "tipo_pagamento",
                "tecnologiaConnessione",
                "migrazioneONuovaLinea",
                "codiceDiMigrazione",
                "consenso_marketing",
                "consenso_profilazione",
                "consenso_terzi",
                "id_vici",
                "ele_pod",
                "ele_mercato_provenienza",
                "ele_potenza_impegnata",
                "prodotto_elettrico",
                "ele_ex_societa_vendita",
                "gas_pdr",
                "gas_mercato_provenienza",
                "gas_categoria_uso_aeeg",
                "prodotto_gas",
                "gas_ex_societa_vendita",
                "codice_iban",
                "nome_banca",
                "contoTitolareFornitura",
                "ele_consumo_annuo",
                "codice_contratto_elettrico",
                "gas_consumo_annuo",
                "codice_contratto_gas",
                "check_pod",
                "check_pdr"
            ]

        };
    },
    submitToCrm: function (data) {
        //{"submission":{"tipoCliente":"residenziale","tipologia":"standard","tipologia_offerta":{"id":1,"item_key":"1","label":"SWITCH","additional":null},"tipocontratto":{"contrattoLuce":true,"contrattoGAS":true},"campagna":{"id":1,"item_key":null,"label":"LANDING","additional":""},"nome":"VINCENZO","cognome":"ARENA","data_nascita":"24/02/1976","luogo_nascita":{"id":4984,"item_key":"7215","label":"NAPOLI","provincia":"NA","cap":"80100","codice_catastale":"F839","additional":null,"swi_int":0,"swi_fat":0,"swi_fru_ele":0,"swi_fru_gas":0,"swi_luo_nas":-1},"stato_nascita":{"id":132,"item_key":"138","label":"ITALIA","iso":"","additional":null},"genere":"M","codice_fiscale":"RNAVCN76B24F839N","cellulare_intestatario":"3332853761","email_intestatario":"ROSALICARDI@GMAIL.COM","telefono_intestatario":"","cellulare_lead":"3332853761","tipo_documento":{"id":2,"item_key":"1","label":"CARTA DI IDENTITA'","additional":"CI"},"numero_documento":"CA90067PP","ente_rilascio_documento":"comune","data_rilascio_documento":"24/02/2023","titolarita_fornitura":{"id":1,"item_key":"1","label":"PROPRIETARIO","additional":null},"modalita_bolletta":"online","tipo_indirizzo_intestatario":{"id":454,"item_key":"459","label":"VIA","additional":null},"indirizzo_intestatario":"NAPOLI PRIMA TRAVERSA ","numero_civico_intestatario":"2","provincia_intestatario":{"id":63,"item_key":"29","label":"NAPOLI","code":"NA"},"localita_intestatario":{"id":4959,"item_key":"7130","label":"MUGNANO DI NAPOLI","provincia":"NA","cap":"80018","codice_catastale":"F799","additional":null,"swi_int":-1,"swi_fat":-1,"swi_fru_ele":-1,"swi_fru_gas":-1,"swi_luo_nas":-1},"frazione_intestatario":{},"indirizzofornituracorrisponderesidenza":true,"indirizzorecapitocorrisponderesidenza":true,"delegatocorrispondecliente":true,"tipo_pagamento":"rid","tecnologiaConnessione":"","migrazioneONuovaLinea":"","codiceDiMigrazione":"","consenso_marketing":true,"consenso_profilazione":true,"consenso_terzi":false,"id_vici":"85274","ele_pod":"IT001E80928736","ele_mercato_provenienza":{"id":1,"item_key":"1","label":"LIBERO","additional":null},"ele_potenza_impegnata":3,"prodotto_elettrico":{"id":19422,"item_key":"283969","label":"IREN REVOLUTION LUCE","code":"IEDOIRLD201130","valid_from":"2020-10-01T00:00:00.000Z","valid_to":null,"tipo_ser":"SITO ELETTRICO","des_soc":"SOLOWEB S.r.l.","cod_soc":"SW","des_par":"IREN","des_seg_off":"STANDARD","des_uso_for":"ABITATIVO","des_ope":null,"cod_tip_con":"RE"},"ele_ex_societa_vendita":{"id":537,"item_key":"733","label":"GRUPPO SINERGY","ope":"SWITCH","servizio":"SITO ELETTRICO","additional":null,"valid_from":null,"valid_to":null},"gas_pdr":"00352505556800","gas_mercato_provenienza":{"id":1,"item_key":"1","label":"LIBERO","additional":null},"gas_categoria_uso_aeeg":{"id":3,"item_key":"3","label":"C3 - RISCALDAMENTO + USO COTTURA CIBI E/O PRODUZIONE DI ACQUA CALDA SANITARIA","additional":null},"prodotto_gas":{"id":19424,"item_key":"283968","label":"IREN 10 PER TRE GAS","code":"IGDODPTG201130","valid_from":"2020-10-01T00:00:00.000Z","valid_to":null,"tipo_ser":"SITO GAS","des_soc":"SOLOWEB S.r.l.","cod_soc":"SW","des_par":"IREN","des_seg_off":"STANDARD","des_uso_for":"ABITATIVO","des_ope":null,"cod_tip_con":"RG"},"gas_ex_societa_vendita":{"id":538,"item_key":"845","label":"GRUPPO SINERGY","ope":"SWITCH","servizio":"SITO GAS","additional":null,"valid_from":null,"valid_to":null},"codice_iban":"IT43P3608105138294316394331","nome_banca":"POSTE ITALIANE ","contoTitolareFornitura":true,"ele_consumo_annuo":900,"codice_contratto_elettrico":"BB1006630","gas_consumo_annuo":800,"codice_contratto_gas":"BB1006630","check_pod":{},"check_pdr":{}},"data":{},"pdf":{},"instant":{},"email":"ROSALICARDI@GMAIL.COM","firstname":"VINCENZO","lastname":"ARENA"}
        //https://app.soloweb.net/#/document/history

    }
}
CrmService.init();
export default CrmService;